"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeCustomerHandler = void 0;
const tslib_1 = require("tslib");
const rxjs_1 = require("rxjs");
const MessageType_1 = require("../message/MessageType");
const Challenge_1 = require("./Challenge");
const EndpointType_1 = require("../endpoint/EndpointType");
const IResult_1 = require("../shared/IResult");
const Reason_1 = require("../shared/Reason");
class ChallengeCustomerHandler {
    constructor(router, joinService, customerChallengedHandler, messagingClient, webauthn) {
        this.router = router;
        this.joinService = joinService;
        this.customerChallengedHandler = customerChallengedHandler;
        this.messagingClient = messagingClient;
        this.webauthn = webauthn;
        this.challengeCustomerObservable = new rxjs_1.Subject();
        this.router.setHandler(MessageType_1.MessageType.ChallengeCustomerRequest, this);
    }
    handle(message) {
        if (this.isChallengeCustomer(message)) {
            const supported = this.webauthn.browserSupportsWebauthn();
            if (this.isFIDOChallenge(message) && !supported) {
                const result = {
                    action: IResult_1.Action.DECLINED,
                    reasons: [Reason_1.Reason.DEVICE_DOESNT_SUPPORT],
                };
                this.sendChallengeCustomerResponse(message, result);
                return;
            }
            const result = {
                action: IResult_1.Action.PENDING,
            };
            this.sendChallengeCustomerResponse(message, result);
            const challengeCustomer = new Challenge_1.Challenge(message, this.webauthn, this.joinService, this.customerChallengedHandler);
            this.challengeCustomerObservable.next(challengeCustomer);
        }
    }
    onChallengeCustomer() {
        return this.challengeCustomerObservable;
    }
    isFIDOChallenge(message) {
        const fidoAuthenticator = message.payload.endpoints.find(endpoint => {
            return (endpoint.type === EndpointType_1.EndpointType.FIDO_AUTHENTICATOR ||
                endpoint.type === EndpointType_1.EndpointType.FIDO_AUTHENTICATOR_CROSS_PLATFORM ||
                endpoint.type === EndpointType_1.EndpointType.FIDO_AUTHENTICATOR_PLATFORM);
        });
        return fidoAuthenticator ? true : false;
    }
    sendChallengeCustomerResponse(message, result) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = {
                messageName: MessageType_1.MessageType.ChallengeCustomerResponse,
                payload: {
                    messageID: message.payload.messageID,
                    interaction: {
                        entersektInteractionID: message.payload.interaction.entersektInteractionID,
                        type: message.payload.interaction.type,
                    },
                    result,
                },
            };
            return this.messagingClient.send(response);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isChallengeCustomer(object) {
        return (object.payload instanceof Object &&
            "payload" in object &&
            "channelInstruction" in object.payload &&
            "messageID" in object.payload &&
            "interaction" in object.payload &&
            "endpoints" in object.payload &&
            "authentication" in object.payload);
    }
}
exports.ChallengeCustomerHandler = ChallengeCustomerHandler;
//# sourceMappingURL=ChallengeCustomerHandler.js.map